/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ noun: NonNullable<unknown> }} Endpoint_Cost_Count_LabelInputs */

const en_endpoint_cost_count_label = /** @type {(inputs: Endpoint_Cost_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Number of ${i?.noun}`)
};

const zh_hans1_endpoint_cost_count_label = /** @type {(inputs: Endpoint_Cost_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`数量（${i?.noun}）`)
};

const pt_br2_endpoint_cost_count_label = /** @type {(inputs: Endpoint_Cost_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quantidade de ${i?.noun}`)
};

const es_endpoint_cost_count_label = /** @type {(inputs: Endpoint_Cost_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cantidad de ${i?.noun}`)
};

const fr_endpoint_cost_count_label = /** @type {(inputs: Endpoint_Cost_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nombre de ${i?.noun}`)
};

const de_endpoint_cost_count_label = /** @type {(inputs: Endpoint_Cost_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anzahl ${i?.noun}`)
};

const ru_endpoint_cost_count_label = /** @type {(inputs: Endpoint_Cost_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Количество ${i?.noun}`)
};

const it_endpoint_cost_count_label = /** @type {(inputs: Endpoint_Cost_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Numero di ${i?.noun}`)
};

/**
* | output |
* | --- |
* | "Number of {noun}" |
*
* @param {Endpoint_Cost_Count_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_count_label = /** @type {((inputs: Endpoint_Cost_Count_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_Count_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_count_label(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_count_label(inputs)
	if (locale === "es") return es_endpoint_cost_count_label(inputs)
	if (locale === "fr") return fr_endpoint_cost_count_label(inputs)
	if (locale === "de") return de_endpoint_cost_count_label(inputs)
	if (locale === "ru") return ru_endpoint_cost_count_label(inputs)
	if (locale === "it") return it_endpoint_cost_count_label(inputs)
	return en_endpoint_cost_count_label(inputs)
});